<template>
  <img
    class="object-contain w-full"
    :class="[
      $attrs.class ? $attrs.class : 'h-12'
    ]"
    alt="Visa logo"
    src="@/assets/image/logo-visa.svg"
  />
</template>